module.exports = __webpack_public_path__ + "static/media/csharp.e7b8fcd4.png";